import { Button, InputLabel } from '@mui/material'
import React, { useEffect, useState } from 'react'
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import IconNewRecord from "src/assets/images/icon_newrecord.svg";
import { useDispatch, useSelector } from 'react-redux';
import { GoodsInDocumentUpload, commonFileUpload } from "src/thunks/dashboard";
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { GetError } from 'src/constant';
import RemoveCircleOutlineOutlinedIcon from "@mui/icons-material/RemoveCircleOutlineOutlined";
import _, { uniqueId } from 'lodash';
import { DispatchDocumentUpload } from 'src/thunks/dispatchOrder';




const UploadDoc = ({ toggle, ActiveData, getDispatchOrderInDataFunc }) => {
    const uploadeddocument = _.filter(
        ActiveData?.dispatchEvidences || [],
        (d) => d.typeId === 25
    );

    const lookupValues = useSelector((state) => state.lookup.data);
    const dispatch = useDispatch();
    const params = useParams();
    let shipmentId = parseInt(params.id);
    const [documentLoader, setDocumentLoader] = useState(false);
    const [newDocsArray, setNewDocsArray] = useState([]);



    useEffect(() => {
        setNewDocsArray(uploadeddocument)
    }, [])



    const documentUpload = async (e) => {
        setDocumentLoader(true);
        const files = e.target.files;
        const formData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append("files", files[i]);
        }
        try {
            let res = await dispatch(commonFileUpload(formData)).unwrap();
            setDocumentLoader(false);
            let documentType = lookupValues.find((v) => v.name === "Documents").id;
            const processedData = res.map((result) => ({
                ...result,
                type: documentType,
                isDamaged: false,
                isToBeDeleted: null,
                dispatchId: ActiveData?.id || 0,
            }));
            processedData &&
                processedData[0] &&
                processedData.forEach((item) => {
                    setNewDocsArray((prevState) => {
                        return [
                            ...prevState,
                            {
                                id: item.id || 0,
                                dispatchId: item.dispatchId,
                                url: item.url,
                                uniqueFileId: item.uniqueFileId,
                                fileName: item.fileName,
                                isDamaged: item.isDamaged,
                                typeId: item.type,
                                isToBeDeleted: item.isToBeDeleted,
                            },
                        ];
                    });
                }
                );
        } catch (err) {
            toast.error(GetError(err?.response?.data?.errors) || "something issue");

            setDocumentLoader(false);
        }
    };


    const onsubmitHandler = async () => {
        try {
            const payload =
            {
                dispatchId: ActiveData?.id,
                dispatchEvidences: newDocsArray
            }
            let res = await dispatch(DispatchDocumentUpload(payload))


        } catch (error) {
            toast.error(GetError(error?.response?.data?.errors) || "something issue");
        }
        let data = await getDispatchOrderInDataFunc(params.id)
        toggle(false)
    }

    return (
        <>

            <div className="row " style={{ marginLeft: 5, height: "100%", }}>
                {
                    // --------cross button
                }
                <div style={{ height: "80%", overflow: "scroll" }}>
                    <div>
                        <span style={{ display: "flex", justifyContent: "flex-end", }}>
                            <CancelOutlinedIcon color='red'
                                style={{ cursor: "pointer" }}
                                onClick={() => { toggle(false) }}
                            />
                        </span>
                        <div className="row pt-3 pb-0 mb-2 mt-2 ps-1">
                            <div className="col-md-2">
                                <InputLabel className="goodsin-form-section-header-name">
                                    {" "}
                                    {newDocsArray?.length || 0} DOUCMENTS
                                </InputLabel>
                            </div>
                            <div className="col-md-10">
                                {documentLoader && (
                                    <div
                                        className="spinner-border spinner-border-sm text-primary"
                                        role="status"
                                    >
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                )}
                            </div>
                        </div>
                        {newDocsArray
                            .filter(
                                (item) =>
                                    item.typeId ==
                                    lookupValues.find((v) => v.name === "Documents").id &&
                                    !item.isToBeDeleted
                            )
                            .map((d, index) => {
                                return (
                                    <div className="row mt-2" key={index}>
                                        <div className="col-md-4">{d?.fileName || ""}</div>
                                        <div className="col-md-4">

                                        </div>
                                        <div
                                            className="col-md-4"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => {
                                                let OldData = _.cloneDeep(setNewDocsArray);
                                                _.remove(
                                                    OldData,
                                                    (i) => i.uniqueFileId === d.uniqueFileId
                                                );
                                                setNewDocsArray([...OldData]);
                                            }}
                                        >
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyItems: "center",
                                                    color: "red",
                                                }}
                                                onClick={() => {
                                                    let OldData = _.cloneDeep(newDocsArray);
                                                    _.remove(
                                                        OldData,
                                                        (i) => i.uniqueFileId === d.uniqueFileId
                                                    );
                                                    setNewDocsArray([...OldData]);
                                                }}
                                            >
                                                <RemoveCircleOutlineOutlinedIcon fontSize="20" />
                                                <InputLabel
                                                    style={{ fontSize: 10, marginTop: -3, color: "red" }}
                                                >
                                                    {" "}
                                                    Remove
                                                </InputLabel>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        <div className="mt-3" >
                            <div className="fileUpload-doc">
                                <input
                                    type="file"
                                    className="upload"
                                    multiple
                                    accept=".doc, .txt , .pdf"
                                    onChange={(e) => documentUpload(e)}
                                />
                                <div>
                                    <img src={IconNewRecord} alt="add" />
                                    <span className="add-doc-button-style">ADD DOCUMENT</span>
                                </div>
                                <div></div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    // -------buttons cancel or something 
                }
                <div style={{ height: "20%", display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                    <div style={{ marginRight: 10 }} >
                        <Button
                            onClick={() => onsubmitHandler()}
                            variant="outlined"
                            style={{ marginRight: 10 }}
                        >submit</Button>
                        <Button onClick={() => toggle(false)}
                            variant="outlined"
                            color='error'
                        > cancel</Button>
                    </div>
                </div>
            </div>


        </>
    )
}
export default UploadDoc